import { createReducer, on } from '@ngrx/store';

import { BossActions } from './actions';
import { bossAdapter, bossInitialState, BossState } from './state';

const getReportsReducer = [
  on(BossActions.GetItems.request, (state: BossState) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(BossActions.GetItems.success, (state: BossState, { items }) =>
    bossAdapter.setAll(items, { ...state, isLoading: false }),
  ),
];

const refreshReportReducer = [
  on(BossActions.Refresh.request, (state: BossState, { item }) =>
    bossAdapter.updateOne(
      {
        id: item.period,
        changes: { ...item, isRefreshing: true },
      },
      {
        ...state,
        error: null,
      },
    ),
  ),
  on(BossActions.Refresh.success, (state: BossState, { item }) =>
    bossAdapter.updateOne(item, state),
  ),
];

const downloadReducer = [
  on(BossActions.Download.request, (state: BossState, { item }) =>
    bossAdapter.updateOne(
      {
        id: item.period,
        changes: { ...item, isDownloading: true },
      },
      {
        ...state,
        error: null,
      },
    ),
  ),
  on(BossActions.Download.success, (state: BossState, { item }) =>
    bossAdapter.updateOne(
      { id: item.period, changes: { ...item, isDownloading: false } },
      state,
    ),
  ),
];

const failureReducer = [
  on(BossActions.failure, (state: BossState, { item, errorMessage }) =>
    item
      ? bossAdapter.updateOne(
          {
            id: item.period,
            changes: { ...item, isDownloading: false, isRefreshing: false },
          },
          {
            ...state,
            isLoading: false,
            error: errorMessage,
          },
        )
      : {
          ...state,
          isLoading: false,
          error: errorMessage,
        },
  ),
];

export const BossReducer = createReducer<BossState>(
  bossInitialState,
  ...getReportsReducer,
  ...refreshReportReducer,
  ...downloadReducer,
  ...failureReducer,
);
